import "../../assets/css/tabs/qualitySurvey.css"

import certificationList from "../../assets/jsonData/certificationList.json"

import commentBlank from "../../assets/images/commentBlank.svg"
import commentFill from "../../assets/images/commentFill.svg"
import close from "../../assets/images/close.svg"
import deleteIcon from "../../assets/images/delete.svg"
import arrowMenu from "../../assets/images/arrowForward.svg"

import React, { useEffect, useRef, useState } from "react"
import Swal from "sweetalert2"
import { useAuth } from "../../context/auth-user"

export default function QualitySurvey(props) {
	// VARIABLE TO MANAGE USER LOGGED IN
	const { user } = useAuth()
	const userLogged = user?.selectedProfile

	// VARIABLE TO MANAGE THE QUALITY SURVEY DATA
	const qualitySurveyCopy = props.qualitySurvey

	// VARIABLE TO MANAGE THE COPY CERTIFICATION LIST
	const [certificationListCopy, setCertificationListCopy] = useState(null)

	// VARIABLE TO MANAGE THE COMENTS
	const [certificationsCommentMenu, setCertificationsCommentMenu] = useState(false);
	const [questionsCommentMenu, setQuestionsCommentMenu] = useState(false);

	// REFERENCE TO MANAGE THE MENUS DROPDOWNS
	const certificationMenuRef = useRef(null)
	const certificationsCommentMenuRef = useRef(null);
	const questionsCommentMenuRef = useRef(null);

	useEffect(() => {
		setCertificationListCopy(certificationList)

		document.body.addEventListener("click", closeMenus)

		return function cleanUp() {
			document.body.removeEventListener("click", closeMenus)
		}
	}, [])

	// FUNCTION TO MANAGE THE MENUS
	const closeMenus = (e) => {
		if (!certificationsCommentMenuRef.current.contains(e.target)) {
			setCertificationsCommentMenu(false)
		}

		if (!questionsCommentMenuRef.current.contains(e.target)) {
			setQuestionsCommentMenu(false)
		}

		if (certificationMenuRef.current && certificationMenuRef.current.contains(e.target)) {
			const allMenus = Array.prototype.slice.call(document.getElementsByClassName("certificationMenu"))

			allMenus.map(element => {
				element.classList.remove("show")
			})

			certificationMenuRef.current.nextElementSibling.classList.toggle("show")
		} else {
			const allMenus = Array.prototype.slice.call(document.getElementsByClassName("certificationMenu"))

			allMenus.map(element => {
				element.classList.remove("show")
			})
		}
	}

	// FUNCTION TO HANDLE THE CHANGE OF THE QUALITY SURVEY
	const handleQualitySurveyCommentChange = (property, value) => {
		qualitySurveyCopy[property] = value

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNCTION TO HANDLE THE ADD CERTIFICATION
	const handleAddCertification = () => {
		qualitySurveyCopy.certifications.push({
			certificationName: "",
			registryNumber: "",
			organizationName: "",
			expeditionDate: "",
			expiredDate: "",
			certification: {
				document: null,
				uploadedAt: null,
				yearCreatedAt: null,
				monthCreatedAt: null,
				dayCreatedAt: null,
			}
		})

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNCTION TO HANDLE THE DELETE CERTIFICATION
	const handleDeleteCertification = (position) => {
		qualitySurveyCopy.certifications.splice(position, 1)

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNCTION TO HANDLE THE CHANGE OF THE CERTIFICATIONS
	const handleCertificationChange = (position, property, value) => {
		if (property === "certification") {
			// In this case value have the element target
			if (value && value.files[0]) {
				if (value.files[0].type === "application/pdf") {
					qualitySurveyCopy.certifications[position][property].document = value.files[0]
				} else {
					value.value = null
					qualitySurveyCopy.certifications[position][property].document = null

					Swal.fire({
						icon: 'error',
						text: 'The file is not a PDF.',
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					})
				}
			} else {
				qualitySurveyCopy.certifications[position][property].document = null
			}
		} else {
			qualitySurveyCopy.certifications[position][property] = value
		}

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNTION TO VALIDATE IF THE CERTIFICATION EXIST
	const validateCertification = (value, position) => {
		if (value !== "" && !certificationList.some(certification => certification.toUpperCase() === value.toUpperCase())) {
			handleFilterList("", position)
			Swal.fire({
				icon: 'error',
				text: 'Please select a certification from our list',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
		}
	}

	// FUNCTION TO HANDLE THE CHANGE OF THE QUESTION
	const handleQuestionChange = (position, property, value) => {
		qualitySurveyCopy.questions[position][property] = value

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNCTION TO HANDLE THE CHANGE OF THE QUESTION
	const handleSubQuestionChange = (positionQuestion, positionSubQuestion, property, value) => {
		qualitySurveyCopy.questions[positionQuestion].subQuestions[positionSubQuestion][property] = value

		props.setSupplier(prevState => {
			return {
				...prevState,
				qualitySurvey: qualitySurveyCopy
			}
		})
	}

	// FUNCTION TO FILTER THE CERTIFICATION LIST
	const handleFilterList = (textRecived, position) => {
		const list = certificationList.filter(listValue => listValue.toUpperCase().includes(textRecived.toUpperCase()))

		setCertificationListCopy(list)
		handleCertificationChange(position, "certificationName", textRecived)
	}

	const disabledFunctions = userLogged && (userLogged.rol === "Supplier" || userLogged.rol === "Document manager")

	return (
		<section className="qualitySurvey">
			<div className="titleAndActions">
				<h5 className="titleSection">
					Certifications
				</h5>
				<img ref={certificationsCommentMenuRef} className="comment" src={qualitySurveyCopy.certificationsComment ? commentFill : commentBlank} alt="Prodensa Supplier" onClick={() => setCertificationsCommentMenu(!certificationsCommentMenu)} />
				<div className={`commentContainer ${certificationsCommentMenu ? "showMenu" : ""}`}>
					<img className={`${disabledFunctions ? "d-none" : ""}`} src={close} alt="Prodensa Supplier" />
					<h5>Comments</h5>
					<textarea
						value={qualitySurveyCopy.certificationsComment}
						rows={5}
						onChange={(e) => handleQualitySurveyCommentChange("certificationsComment", e.target.value)}
						placeholder="Write comment..."
						disabled={disabledFunctions}
						onClick={(e) => e.stopPropagation()}
					/>
					<div className={`actions ${disabledFunctions ? "d-none" : ""}`}>
						<button className="btnBgBlueTextGradient" onClick={() => handleQualitySurveyCommentChange("certificationsComment", "")}>Cancel</button>
						<button className="btnBgBlueTextGradient">Apply comment</button>
					</div>
				</div>
			</div>
			{qualitySurveyCopy && qualitySurveyCopy.certifications.map((certification, indexCertification) => (
				<div key={indexCertification} className="inputSections">
					<div className="inputContainer" data-name="certificationInput">
						<span className="label">Certification</span>
						<input value={certification.certificationName} type="text" placeholder="Type a certification"
							onChange={(e) => handleFilterList(e.target.value, indexCertification)}
							onFocus={(e) => { certificationMenuRef.current = e.target; setCertificationListCopy(certificationList) }}
							onBlur={(e) => validateCertification(e.target.value, indexCertification)}
						/>
						<div className="certificationMenu">
							{certificationListCopy?.map((certification, index) => (
								<span className="optionMenu" key={index}
									onMouseDown={() => {
										handleCertificationChange(indexCertification, "certificationName", certification);
										setCertificationListCopy(certificationList);
									}}>
									{certification}
								</span>
							))}
						</div>
						<img className="arrowMenu" src={arrowMenu} alt="Prodensa Supplier" />
						<img className="deleteIcon d-lg-none" src={deleteIcon} onClick={() => handleDeleteCertification(indexCertification)} alt="Prodensa Supplier" />
					</div>
					<div className="inputContainer">
						<span className="label">Registry number</span>
						<input value={certification.registryNumber} type="text" placeholder="Registry number"
							onChange={(e) => handleCertificationChange(indexCertification, "registryNumber", e.target.value)}
						/>
					</div>
					<div className="inputContainer">
						<span className="label">Certification organization name</span>
						<input value={certification.organizationName} type="text" placeholder="Certification organization name"
							onChange={(e) => handleCertificationChange(indexCertification, "organizationName", e.target.value)}
						/>
					</div>
					<div className="inputContainer calendar">
						<span className="label">Expedition date</span>
						<input value={certification.expeditionDate} type="date"
							onChange={(e) => handleCertificationChange(indexCertification, "expeditionDate", e.target.value)}
						/>
					</div>
					<div className="inputContainer calendar">
						<span className="label">Expired date</span>
						<input value={certification.expiredDate} type="date"
							onChange={(e) => handleCertificationChange(indexCertification, "expiredDate", e.target.value)}
						/>
					</div>
					<div className="inputContainer">
						<span className="label">Certification document</span>
						<div className="fileContainer">
							{certification.certification.document
								? <React.Fragment>
									<a className="downloadFile btnBgBlueTextGradient"
										href={process.env.REACT_APP_URI_UPLOADS +
											props.rfc + "/" +
											(certification.certification.document.name ?? certification.certification.document)}
										target="_blank">View attached file</a>
									<span className="fileName">{certification.certification.document.name ?? certification.certification.document}</span>
									<img className="close" src={close} alt="Prodensa Supplier"
										onClick={() => handleCertificationChange(indexCertification, "certification", "")} />
								</React.Fragment>
								: <input type="file" accept=".pdf"
									onChange={(e) => handleCertificationChange(indexCertification, "certification", e.target)}
								/>}
						</div>
					</div>
					<div className="inputContainer d-none d-lg-flex moreWidth">
						<img className="deleteIcon" src={deleteIcon} onClick={() => handleDeleteCertification(indexCertification)} alt="Prodensa Supplier" />
					</div>
				</div>
			))}
			<button className="btnBgBlueTextGradient" onClick={() => handleAddCertification()}>Add certification</button>

			<div className="titleAndActions">
				<h5 className="titleSection">
					Questions <bg-grey>(If applicable)</bg-grey>
				</h5>
				<img ref={questionsCommentMenuRef} className="comment" src={qualitySurveyCopy.questionsComment ? commentFill : commentBlank} alt="Prodensa Supplier" onClick={() => setQuestionsCommentMenu(!questionsCommentMenu)} />
				<div className={`commentContainer ${questionsCommentMenu ? "showMenu" : ""}`}>
					<img className={`${disabledFunctions ? "d-none" : ""}`} src={close} alt="Prodensa Supplier" />
					<h5>Comments</h5>
					<textarea
						value={qualitySurveyCopy.questionsComment}
						rows={5}
						onChange={(e) => handleQualitySurveyCommentChange("questionsComment", e.target.value)}
						placeholder="Write comment..."
						disabled={disabledFunctions}
						onClick={(e) => e.stopPropagation()}
					/>
					<div className={`actions ${disabledFunctions ? "d-none" : ""}`}>
						<button className="btnBgBlueTextGradient" onClick={() => handleQualitySurveyCommentChange("questionsComment", "")}>Cancel</button>
						<button className="btnBgBlueTextGradient">Apply comment</button>
					</div>
				</div>
			</div>
			{qualitySurveyCopy && qualitySurveyCopy.questions.map((question, indexQuestion) => (
				<div key={indexQuestion} className="inputSections">
					<div className="titleAndActions">
						<h5 className="titleQuestion">{question.question}</h5>
					</div>
					{question.typeQuestion === "Radio" && <div className="inputContainer radio">
						<input id={`questionYes${indexQuestion}`} type="radio" name={`question${indexQuestion}`}
							checked={question.answer ? true : false}
							onChange={() => handleQuestionChange(indexQuestion, "answer", true)}
						/>
						<label htmlFor={`questionYes${indexQuestion}`}>Yes</label>
						<input id={`questionNo${indexQuestion}`} type="radio" name={`question${indexQuestion}`} className="no"
							checked={question.answer ? false : true}
							onChange={() => handleQuestionChange(indexQuestion, "answer", false)}
						/>
						<label htmlFor={`questionNo${indexQuestion}`}>No</label>
					</div>}

					{question.typeQuestion === "Text" && <div className="inputContainer moreWidth">
						<input type="text" value={question.answer}
							onChange={(e) => handleQuestionChange(indexQuestion, "answer", e.target.value)}
						/>
					</div>}

					{(question.answer || !question.typeQuestion) && question.subQuestions.map((subQuestion, indexSubQuestion) => (
						<React.Fragment key={indexSubQuestion}>
							{subQuestion.typeQuestion === "Radio" && <div className="inputContainer radio">
								<span className="label">{subQuestion.question}</span>
								<input id={`questionYes${indexQuestion}subQuestionYes${indexSubQuestion}`} type="radio"
									name={`question${indexQuestion}subQuestion${indexSubQuestion}`}
									checked={subQuestion.answer ? true : false}
									onChange={() => handleSubQuestionChange(indexQuestion, indexSubQuestion, "answer", true)}
								/>
								<label htmlFor={`questionYes${indexQuestion}subQuestionYes${indexSubQuestion}`}>Yes</label>
								<input id={`questionNo${indexQuestion}subQuestionNo${indexSubQuestion}`} type="radio"
									name={`question${indexQuestion}subQuestion${indexSubQuestion}`} className="no"
									checked={subQuestion.answer ? false : true}
									onChange={() => handleSubQuestionChange(indexQuestion, indexSubQuestion, "answer", false)}
								/>
								<label htmlFor={`questionNo${indexQuestion}subQuestionNo${indexSubQuestion}`}>No</label>
							</div>}

							{subQuestion.typeQuestion === "Text" && <div className="inputContainer moreWidth">
								<div className="w-100"></div>
								<span className="label">{subQuestion.question}</span>
								<input type="text"
									onChange={(e) => handleSubQuestionChange(indexQuestion, indexSubQuestion, "answer", e.target.value)}
								/>
							</div>}
						</React.Fragment>
					))}
				</div>
			))}
		</section >
	)
}   